module.exports = __webpack_public_path__ + "static/media/image 51.72d2bd63.png";